var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Box, Typography } from '@pinwheel/origami';
import { useScreenHeaderFocus } from '../hooks/useScreenHeaderFocus';
export var SCREEN_TITLE_HEADER_DEFAULT_ID = 'pinwheel-accessible-screen-header';
// Wrapper around <Typography> which should be used for the title header of
// every screen, in order to fulfill accessibility requirements. By default, the
// header element is autofocused (using the `useScreenHeaderFocus` hook) so that
// page navigation with screen readers starts from the top of the screen.
export var ScreenTitleHeader = function (_a) {
    var _b = _a.shouldFocus, shouldFocus = _b === void 0 ? true : _b, as = _a.as, id = _a.id, color = _a.color, rest = __rest(_a, ["shouldFocus", "as", "id", "color"]);
    useScreenHeaderFocus({ enabled: shouldFocus });
    return (React.createElement(Box, null,
        React.createElement(Typography, __assign({ as: as || 'h2', id: id || SCREEN_TITLE_HEADER_DEFAULT_ID, color: color || 'title' }, rest))));
};
